import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import About from './pages/About'
import Contact from './pages/Contact'
import ESG from './pages/ESG'
import Careers from './pages/Careers'

// Service pages
import CommercialCleaning from './pages/services/CommercialCleaning'
import SpecializedCleaning from './pages/services/SpecializedCleaning'
import HygieneServices from './pages/services/HygieneServices'
import ConsumableServices from './pages/services/ConsumableServices'

// Sector pages
import EducationInstitutions from './pages/sectors/EducationInstitutions'
import CommercialIndustrialResidential from './pages/sectors/CommercialIndustrialResidential'
import Hospitality from './pages/sectors/Hospitality'
import AgedCareHealthcare from './pages/sectors/AgedCareHealthcare'
import TechnologyDataCentres from './pages/sectors/TechnologyDataCentres'
import GovernmentPublic from './pages/sectors/GovernmentPublic'

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/esg" element={<ESG />} />
            <Route path="/careers" element={<Careers />} />
            
            {/* Service routes */}
            <Route path="/services/commercial-cleaning" element={<CommercialCleaning />} />
            <Route path="/services/specialized-cleaning" element={<SpecializedCleaning />} />
            <Route path="/services/hygiene-services" element={<HygieneServices />} />
            <Route path="/services/consumable-services" element={<ConsumableServices />} />
            
            {/* Sector routes */}
            <Route path="/sectors/education-and-institutions" element={<EducationInstitutions />} />
            <Route path="/sectors/commercial-industrial" element={<CommercialIndustrialResidential />} />
            <Route path="/sectors/hospitality" element={<Hospitality />} />
            <Route path="/sectors/aged-care-healthcare" element={<AgedCareHealthcare />} />
            <Route path="/sectors/technology-data-centres" element={<TechnologyDataCentres />} />
            <Route path="/sectors/government-public" element={<GovernmentPublic />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
